import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.korslovo.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-korslovo-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.korslovo.dashboard/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
  overflow: auto;
}

/* ═══ Star Level Banner Themes (8 tiers for 18 levels) ═══ */
.star-banner {
  transition: all 0.5s ease;
}

.star-newcomer {
  background: linear-gradient(135deg, #71717a 0%, #a1a1aa 100%);
}

.star-bronze {
  background: linear-gradient(135deg, #92400e 0%, #d97706 50%, #f59e0b 100%);
}

.star-silver {
  background: linear-gradient(135deg, #475569 0%, #94a3b8 50%, #cbd5e1 100%);
}

.star-gold {
  background: linear-gradient(135deg, #a16207 0%, #eab308 50%, #fde047 100%);
}

.star-platinum {
  background: linear-gradient(135deg, #0e7490 0%, #06b6d4 40%, #a78bfa 100%);
}

.star-diamond {
  background: linear-gradient(135deg, #7c3aed 0%, #a78bfa 30%, #38bdf8 60%, #c084fc 100%);
}

.star-champion {
  background: linear-gradient(135deg, #e11d48 0%, #f59e0b 50%, #e11d48 100%);
  background-size: 200% 200%;
  animation: masterShift 4s ease infinite;
}

.star-master {
  background: linear-gradient(135deg, #dc2626 0%, #f59e0b 25%, #10b981 50%, #3b82f6 75%, #8b5cf6 100%);
  background-size: 200% 200%;
  animation: masterShift 4s ease infinite;
}

@keyframes masterShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
/* Star icon glow */
.star-icon-bg {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
}

.star-glow {
  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.6));
  animation: starPulse 2s ease-in-out infinite;
}

@keyframes starPulse {
  0%, 100% {
    transform: scale(1);
    filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.6));
  }
  50% {
    transform: scale(1.1);
    filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.9));
  }
}
/* XP progress bar shimmer */
.star-progress {
  position: relative;
  overflow: hidden;
}

.star-progress::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: progressShimmer 2s ease-in-out infinite;
}

@keyframes progressShimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
/* Floating star particles */
.star-particle {
  position: absolute;
  color: rgba(255, 255, 255, 0.15);
  font-size: 18px;
  animation: starFloat 6s ease-in-out infinite;
}

.star-p1 {
  top: 10%;
  right: 10%;
  animation-delay: 0s;
  font-size: 14px;
}

.star-p2 {
  top: 60%;
  right: 25%;
  animation-delay: 1.2s;
  font-size: 20px;
}

.star-p3 {
  top: 30%;
  right: 50%;
  animation-delay: 2.4s;
  font-size: 12px;
}

.star-p4 {
  top: 75%;
  right: 65%;
  animation-delay: 3.6s;
  font-size: 16px;
}

.star-p5 {
  top: 15%;
  right: 80%;
  animation-delay: 4.8s;
  font-size: 10px;
}

@keyframes starFloat {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.15;
  }
  50% {
    transform: translateY(-8px) rotate(180deg);
    opacity: 0.35;
  }
}
/* Slow bounce for current star in journey */
@keyframes bounceSlow {
  0%, 100% {
    transform: translateY(0) scale(1.25);
  }
  50% {
    transform: translateY(-4px) scale(1.25);
  }
}
.animate-bounce-slow {
  animation: bounceSlow 2s ease-in-out infinite;
}`],
})
export class PageKorslovoDashboardComponent implements OnInit {
    public ru = RU;
    public loading: boolean = true;
    public data: any = {};
    public userName: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.userName = this.service.auth.session?.name || '';
        await this.loadDashboard();
    }

    public async loadDashboard() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("dashboard");
        if (code === 200) {
            this.data = data || {};
        }

        this.loading = false;
        await this.service.render();
    }

    public get xp() {
        return this.data.xp || {};
    }

    public get game() {
        return this.data.game || {};
    }

    public get starInfo() {
        return this.xp.star_info || { level: 0, name: 'newcomer', icon: '☆', title: 'Новичок (입문)', color: 'zinc' };
    }

    public get nextStar() {
        return this.xp.next_star || null;
    }

    public get progressPct() {
        return this.xp.progress_pct || 0;
    }

    public get allStarLevels() {
        return this.xp.all_star_levels || [];
    }

    public get totalXp() {
        return this.xp.total_xp || 0;
    }

    public get xpBreakdown() {
        return this.xp.xp_breakdown || {};
    }

    public get streakMultiplier() {
        return this.xp.streak_multiplier || 1.0;
    }

    public get bannerTier(): string {
        const level = this.starInfo.level || 0;
        if (level <= 1) return 'newcomer';
        if (level <= 5) return 'bronze';
        if (level <= 8) return 'silver';
        if (level <= 11) return 'gold';
        if (level <= 13) return 'platinum';
        if (level <= 15) return 'diamond';
        if (level === 16) return 'champion';
        return 'master';
    }

    // Star Journey: only show milestone levels for compact view
    public get journeyLevels() {
        const all = this.allStarLevels;
        if (all.length <= 10) return all;
        const milestones = [0, 2, 5, 8, 11, 13, 15, 16, 17];
        return all.filter((sl: any) => milestones.includes(sl.level));
    }

    public formatTime(s: number): string {
        if (!s) return '--:--';
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
    }

    public goLesson(lesson: any) {
        this.service.href(`/learn/${lesson.lesson_id}`);
    }

    public goReview() {
        this.service.href('/review');
    }

    public goCategories() {
        this.service.href('/category');
    }

    public goGame() {
        this.service.href('/game');
    }
}

export default PageKorslovoDashboardComponent;